export class RelationshipPartner {
  status: string = '';
  relationshipStart: string = '';
  dateMarried: string = '';
  intendToMarry: string = '';
  datePlannedMarriage: string = '';
  metInPerson: string = '';
  liveTogether: string = '';
  startedLivingTogether: string = '';
  haveChildren: string = '';
  numChildren: string = '';
  firstMet: string = '';
}